import React from "react";
import { Button, Checkbox, CheckboxGroup } from "@heroui/react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { setSelectedFilter } from "../../../../reducers/slices/selection";
import { NoContentMessage } from "../../../../components/no_content_message";
import { ParagraphShimmer } from "../../../../components/shimmer/shimmer_types";
export function ProductsFilter({ attributes, isLoading, initialLoad }) {
    const dispatch = useDispatch();
    const { filter } = useSelector((state) => state.selectionState);
    const onUpdate = (groupName, values) => {
        dispatch(setSelectedFilter({
            ...filter,
            [groupName]: values,
        }));
    };
    const onReset = () => {
        const clearedObject = Object.keys(filter)
            .map((key) => ({ [key]: [] }))
            .reduce((acc, curr) => ({ ...acc, ...curr }), {});
        dispatch(setSelectedFilter(clearedObject));
    };
    const isFilterEmpty = Object.values(filter).every((value) => value.length === 0);
    if (!initialLoad && (!attributes || attributes.length === 0)) {
        return React.createElement(NoContentMessage, { messages: ["No categories to filter"] });
    }
    return (React.createElement("div", { className: "w-full rounded-xl px-6 py-8 bg-light-blue" }, initialLoad ? (React.createElement("div", null,
        React.createElement(ParagraphShimmer, null))) : (React.createElement("div", null,
        React.createElement("div", { className: "text-xl font-bold pb-1" }, "Filter Products"),
        React.createElement("div", { className: "flex flex-col gap-2" }, attributes?.map((group) => (React.createElement(CheckboxGroup, { orientation: "horizontal", key: group.name, label: group.name, className: "pt-2", isDisabled: isLoading, classNames: { label: "text-primary text-base font-semibold" }, value: filter[group.name] || [], onValueChange: (values) => onUpdate(group.name, values) }, group?.list?.map((attribute) => (React.createElement(Checkbox, { key: attribute, value: attribute, classNames: {
                label: "text-primary/80 text-sm font-medium group-data-[selected=true]:text-white",
                base: "border-2 border-neutral-gray bg-white rounded-lg shadow-sm m-0 data-[selected=true]:bg-primary data-[selected=true]:border-primary",
            } }, attribute))))))),
        React.createElement("div", { className: "flex justify-center pt-8" },
            React.createElement(Button, { variant: "light", color: "primary", isDisabled: isFilterEmpty, startContent: React.createElement(FontAwesomeIcon, { icon: faXmark, size: "1x" }), onPress: onReset }, "Reset"))))));
}
